import React from 'react';
import { Typography } from '@mui/material';
import PolicyHeader from './PolicyHeader';
import { dataOne, privacyPolicyData } from './AboutUsData';
import Policy from './Policy';

function PrivacyPolicy() {
  const searchParams = new URLSearchParams(window.location.search);
  const isMobileParams = searchParams.get('isMobile') === 'true';
  return (
    <div>
      {!isMobileParams && <PolicyHeader />}
      <div className="aboutBackground">
        {!isMobileParams && (
          <Typography className="headerText justifyCenter fw500 pt20 pb30">
            Privacy Policy
          </Typography>
        )}

        <Typography
          variant="body2"
          className="pb20 colorLightBlack"
          component={'p'}
        >
          Privacy Policy for Https://iter.co.in/ Marketing Management
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          If you require any more information or have any questions about our
          privacy policy, please feel free to contact us by email at Privacy. At
          https://iter.co.in/ we consider the privacy of our visitors to be
          extremely important. This privacy policy document describes in detail
          the types of personal information that is collected and recorded by
          https://iter.co.in/and how we use it.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          Log Files
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          Like many other websites, https://iter.co.in/makes use of log files.
          These files merely log visitors into the site – usually a standard
          procedure for hosting companies and a part of hosting services’
          analytics. The information inside the log files includes Internet
          Protocol (IP) addresses, browser type, Internet Service Provider
          (ISP), date/time stamp, referring/exit pages, and possibly the number
          of clicks. This information is used to analyze trends, administer the
          site, track user’s movement around the site, and gather demographic
          information. IP addresses and other such information are not linked to
          any information that is personally identifiable.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          Information collected by us:
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'p'}
          >
            Location Permissions and Data Usage
          </Typography>
          Our app may request access to your device's location for various
          features and functionalities. We understand the importance of user
          privacy and are committed to ensuring that your location data is
          handled responsibly and securely.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            Understanding Location Permissions:
          </Typography>
          &nbsp;Before granting access to your device's location, please review
          the following information to understand how and why we may collect and
          use this data:
        </Typography>
        <Policy policyData={privacyPolicyData} name={'privacyPolicy'} />

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            Reviewing Personal and Sensitive User Data Policy:
          </Typography>
          &nbsp;We adhere to Google Play's policies regarding personal and
          sensitive user data. Our app respects your privacy and is designed to
          minimize the collection and usage of such data to only what is
          necessary for the app's functionality such as authentication / account
          management / communication & updates and so on.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            Updating Our Privacy Policy:
          </Typography>
          &nbsp;To ensure compliance with Google Play's policies and
          regulations, we have updated our privacy policy to reflect our
          commitment to user privacy and data protection. Our privacy policy is
          available on an active URL, non-editable, and specifically refers to
          our app and its handling of user data.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            Accessing Our Privacy Policy:
          </Typography>
          &nbsp;You can access our privacy policy through the following link:
          <a href="https://client.iter.co.in/privacypolicy" target="_blank">
          &nbsp;https://client.iter.co.in/privacypolicy{' '}
          </a>
          . Additionally, a link to our privacy policy is provided on our app's
          store listing page on Google Play and within the app itself.
        </Typography>

        <Typography
          variant="head5 pb20 fw400"
          className="colorLightBlack"
          component={'p'}
        >
          By using our app, you agree to the terms outlined in our privacy
          policy and consent to the collection, usage, and sharing of your data
          as described herein. If you have any questions or concerns about our
          privacy practices, please contact us at{' '}
          <a href="mailto:info@iter.co.in">info@iter.co.in</a>.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            Contact information.
          </Typography>
          &nbsp;We might collect your name, email, mobile number, phone number,
          street, city, state, pin code, country and IP address.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            Information you post.
          </Typography>
          &nbsp;We collect information you post in a public space, on our
          website or on a third-party social media site belonging to
          Https://iter.co.in/
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            Demographic Information.
          </Typography>
          &nbsp;We may collect demographic information about you, events you
          like, events you intend to participate in, tickets you buy, or any
          other information provided during the use of our website. We might
          collect this as a part of a survey also.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            Other information.
          </Typography>
          &nbsp;If you use our website, we may collect information about your IP
          address and the browser you’re using. We might look at what site you
          came from, duration of time spent on our website, pages accessed or
          what site you visit when you leave us. We might also collect the type
          of mobile device you are using, or the version of the operating system
          your computer or device is running.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          We collect information in different ways.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We collect information directly from you.
          </Typography>
          &nbsp;We collect information directly from you when you register for
          an event or buy tickets. We also collect information if you post a
          comment on our websites or ask us a question through phone or email.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We collect information from you passively.
          </Typography>
          &nbsp;We use tracking tools like Google Analytics, Google Webmaster,
          browser cookies and web beacons for collecting information about your
          usage of our website.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We get information about you from third parties.
          </Typography>
          &nbsp;For example, if you use an integrated social media feature on
          our websites. The third-party social media site will give us certain
          information about you. This could include your name and email address.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          Use of your personal information
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We use information to contact you:{' '}
          </Typography>
          &nbsp;We might use the information you provide to contact you for
          confirmation of a purchase on our website or for other promotional
          purposes.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We use information to respond to your requests or questions
          </Typography>
          &nbsp;We might use your information to confirm your registration for
          an event or contest.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We use information to improve our products and services.
          </Typography>
          &nbsp;We might use your information to customize your experience with
          us. This could include displaying content based upon your preferences.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We use information to look at site trends and customer interests.
          </Typography>
          &nbsp;We may use your information to make our website and products
          better. We may combine information we get from you with information
          about you we get from third parties.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We use information for security purposes.
          </Typography>
          &nbsp;We may use information to protect our company, our customers, or
          our websites.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We use information for marketing purposes.
          </Typography>
          &nbsp;We might send you information about special promotions or
          offers. We might also tell you about new features or products. These
          might be our own offers or products, or third-party offers or products
          we think you might find interesting. Or, for example, if you buy
          tickets from us we’ll enroll you in our newsletter.
        </Typography>

        <Typography
          variant="body2"
          component={'p'}
          className="pb20 colorLightBlack"
        >
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We use information to send you transactional communications.
          </Typography>
          &nbsp;We might send you emails or SMS about your account or a ticket
          purchase..
        </Typography>

        <Typography variant="head5 pb20" component={'p'}>
          We use information as otherwise permitted by law.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          Sharing of information with third-parties
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We will share information with third parties who perform services on
            our behalf. We
          </Typography>
          &nbsp;We share information with vendors who help us manage our online
          registration process or payment processors or transactional message
          processors. Some vendors may be located outside of India.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We will share information with the event organizers.
          </Typography>
          &nbsp;We share your information with event organizers and other
          parties responsible for fulfilling the purchase obligation. The event
          organizers and other parties may use the information we give them as
          described in their privacy policies.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We will share information with our business partners.
          </Typography>
          &nbsp;This includes a third party who provide or sponsor an event, or
          who operates a venue where we hold events. Our partners use the
          information we give them as described in their privacy policies.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We may share information if we think we have to in order to comply
            with the law or to protect ourselves.
          </Typography>
          &nbsp;We will share information to respond to a court order or
          subpoena. We may also share it if a government agency or investigatory
          body requests. Or, we might also share information when we are
          investigating potential fraud.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We may share information with any successor to all or part of our
            business.
          </Typography>
          &nbsp;For example, if part of our business is sold we may give our
          customer list as part of that transaction.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            We may share your information for reasons not described in this
            policy.
          </Typography>
          &nbsp; We will tell you before we do this.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          Email Opt-Out
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          <Typography
            variant="head5 pb20 fw600"
            className="colorLightBlack"
            component={'span'}
          >
            You can opt out of receiving our marketing emails.
          </Typography>
          To stop receiving our promotional emails, please email
          mangalore@alt-er.com. It may take about ten days to process your
          request. Even if you opt out of getting marketing messages, we will
          still be sending you transactional messages through email and SMS
          about your purchases.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          Third Party Privacy Policies
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          You should consult the respective privacy policies of these
          third-party ad servers for more detailed information on their
          practices as well as for instructions about how to opt-out of certain
          practices. https://iter.co.in/ privacy policy does not apply to, and
          we cannot control the activities of, such other advertisers or web
          sites. You may find a comprehensive listing of these privacy policies
          and their links here: Privacy Policy Links.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          If you wish to disable cookies, you may do so through your individual
          browser options. More detailed information about cookie management
          with specific web browsers can be found at the browsers’ respective
          websites. What Are Cookies?
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          Third party sites
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          If you click on one of the links to third party websites, you may be
          taken to websites we do not control. This policy does not apply to the
          privacy practices of those websites. Read the privacy policy of other
          websites carefully. We are not responsible for these third party
          sites.
        </Typography>

        <Typography variant="head5 pb20" component={'p'}>
          Children’s Information
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          We believe it is important to provide added protection for children
          online. We encourage parents and guardians to spend time online with
          their children to observe, participate in and/or monitor and guide
          their online activity. https://iter.co.in/does not knowingly collect
          any personally identifiable information from children under the age of
          13. If a parent or guardian believes that https://iter.co.in/has in
          its database the personally-identifiable information of a child under
          the age of 13, please contact us immediately (using the contact in the
          first paragraph) and we will use our best efforts to promptly remove
          such information from our records.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          Grievance Officer
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          In accordance with Information Technology Act 2000 and rules made
          there under, the name and contact details of the Grievance Officer are
          provided below:
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          Online Privacy Policy Only
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          This privacy policy applies only to our online activities and is valid
          for visitors to our website and regarding information shared and/or
          collected there. This policy does not apply to any information
          collected offline or via channels other than this website.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          Updates to this policy
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          This Privacy Policy was last updated on 21/12/2023. From time to time
          we may change our privacy practices. We will notify you of any
          material changes to this policy as required by law. We will also post
          an updated copy on our website. Please check our site periodically for
          updates.
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          Jurisdiction
        </Typography>
        <Typography variant="head5 pb20" component={'p'}>
          If you choose to visit the website, your visit and any dispute over
          privacy is subject to this Policy and the website’s terms of use. In
          addition to the foregoing, any disputes arising under this Policy
          shall be governed by the laws of India.
        </Typography>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
